/** O recorte por responsável permanece suportado na URL/RPC, mas sua seção
 * fica temporariamente fora do painel até voltarmos a expô-la na interface. */
export function isSalesExplorerFilterGroupVisible(id: string): boolean {
  return id !== "owner";
}
